module.exports = __webpack_public_path__ + "img/UX.8db3e03a.png";